<template>
  <BreadCrumb
    :breadcrumb="breadcrumb"
    :title="title"
  />
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
});

const route = useRoute();

const breadcrumb = computed(() => {
  const paths = route.path
    .split('/')
    .filter((path) => path)
    .splice(1);
  paths.pop();
  return paths.map((path, index) => {
    return {
      text: path,
      to: '/' + paths.slice(0, index + 1).join('/'),
    };
  });
});
</script>
